import React from "react";
import { InPageEditingProvider } from "./InPageEditingContext";
import { useValidators } from "formvalidation/hooks";
import ValidatorContext from "formvalidation/FormContext";
import { PreviewPanelContent } from "components/PreviewPanel/PreviewPanel";

interface PreviewPanelSectionTemplateProps {
  enabled: boolean
  onValueChanged: (key: string, value: any) => void
  onSuccessfulUpdate?: () => Promise<void>
}

export const PreviewPanelSectionTemplate = (props: React.PropsWithChildren<PreviewPanelSectionTemplateProps>) => {
  const { children, enabled, onValueChanged } = props;

  const validators = useValidators();

  return <PreviewPanelContent>
    <InPageEditingProvider
      enabled={enabled}
      validate={validators.validateAll}
      onValueChanged={onValueChanged}
      onSuccessfulUpdate={props.onSuccessfulUpdate}
    >
      <ValidatorContext settings={validators.validatorSettings}>
        {children}
      </ValidatorContext>
    </InPageEditingProvider>
  </PreviewPanelContent>
}